import React, { useEffect, useState } from "react";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { MdSearch } from "react-icons/md";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../../Utils/utils";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../RecasUserTable/RecasUserTable.css"
import Select from "react-select";
import moment from "moment";
import Loader from "../../../../Components/loader/loader";
import { toast } from "react-toastify";

const RecasUserTable = () => {
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const LoginToken = GetToken();
    const [leaveRequestDuplicate, setLeaveRequestDuplicate] = useState();
    const [showSidebar, setShowSidebar] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [allHolidays, setAllHolidays] = useState([]);
    const [specificUserId, setSpecificUserId] = useState();
    const [getAllUser, setGetAllUser] = useState([]);
    console.log(getAllUser,"getAllUser");
    const [projectDetails, setProjectDetails] = useState([]);
    const [projectId, setProjectId] = useState();
    console.log(projectId,'projectId');
    const [monthStartDate, setMonthStartDate] = useState();
    const [monthEndDate, setMonthEndDate] = useState();
    const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    const getMonthStartEndDates = (year, monthIndex) => {
        const startDate = moment(new Date(year, monthIndex)).format('YYYY/MM/DD');
        const endDate = moment(new Date(year, monthIndex + 1, 0)).format('YYYY/MM/DD');
        return {
            startDate,
            endDate
        };
    };

    const monthOptions = monthNames.map((month, index) => ({
        label: month,
        value: index + 1,
        dates: getMonthStartEndDates(new Date().getFullYear(), index),
    }));


    const GetAllUser = () => {
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Recas/GetAllUsers`,
        };
        axios(option)
            .then((e) => {
                const allData = JSON.parse(e?.data?.data)
                setGetAllUser(allData?.Result);

            })
            .catch(() => { });
    };

    const GetProjectData = () => {
        const option = {
            method: "GET",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Recas/GetAllProjects`,
        };
        axios(option)
            .then((e) => {
                const projectData = JSON.parse(e?.data?.data)
                setProjectDetails(projectData?.Result);
                setProjectId(projectData?.Result)

            })
            .catch(() => { });
    };
    useEffect(() => {
        GetAllUser();
        GetProjectData();
    }, []);

    const handleshowHolidayModal = (e) => {
        setSpecificUserId(e?.RecasUserId)
        setShowModal(true);

    };
    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleDataSearch = (e) => {
        const searchTerm = e?.target?.value?.toLowerCase();
        if (searchTerm) {
            const filteredData = leaveRequestDuplicate.filter((item) =>
                item?.HolidayName?.toLowerCase()?.includes(searchTerm)
            );
            setAllHolidays(filteredData);
        } else {
            setAllHolidays(leaveRequestDuplicate);
        }
    };
    useEffect(() => {
        if (window.innerWidth < 600) {
            const timeoutId = setTimeout(() => {
                setShowSidebar(false);
            }, 1000);
            return () => clearTimeout(timeoutId);
        }
        setShowSidebar(true);
    }, []);


    const handleSubmitModel = (e) => {
        setLoading(true);
        const data = {};
        data.UserId = specificUserId;
        data.StartDate = monthStartDate;
        data.EndDate = monthEndDate;
        data.ProjectId = projectId;

        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `https://attendanceapi.elitewebdemo.com/api/Recas/ScreenCaptures`,
            data: { data: JSON.stringify(data) },
        };
        axios(option)
            .then((e) => {
                setLoading(false);
                const responceData = e?.data?.data;
                const verifyData = JSON.parse(responceData);
                if (e?.status === 200) {
                    toast.success(e?.data?.message);

                    navigate("/Adm/RecasScreenshot", { state: { data: verifyData } });
                }
            })
            .catch((error) => {
                setLoading(false);
            });
    };

    return (
        <>
            {loading ? <Loader /> : null}
            <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <div className="d-flex">
                <Sidebar showSidebar={showSidebar} />
                <>
                    <div
                        className={
                            showSidebar
                                ? "main-container-of-all-employees-Attendance-Holiday"
                                : "main-container-of-all-employees-page-new-Attendance-management"
                        }
                    >
                        <div className="inner-container-of-all-employees-page-Holiday ">
                            <div className="header-of-employees-page-Holiday row">
                                <div className="all-employee-Attendance-Holiday col">
                                    <h4>Recas</h4>
                                </div>
                                <div className="all-employees-Attendance-Holiday col">
                                    <div className="home-icon-Attendance-Holiday">
                                        <BiHomeAlt className="home-icon-header-Attendance-Holiday" />
                                    </div>
                                    <div className="arrow-icon-Attendance-Holiday">
                                        <MdKeyboardArrowRight />
                                    </div>
                                    <div className="employee-text-Attendance-Holiday">
                                        <p>Recas </p>
                                    </div>
                                    <div className="arrow-icon-Attendance-Holiday">
                                        <MdKeyboardArrowRight />
                                    </div>
                                    <div className="all-employee-text-Attendance-Holiday">
                                        <p>Recas </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="body-part-outer-Attendance-Holiday">
                            <div className="inner-body-container-of-employee-Attendance-Holiday row-12">
                                <div className=" first-side-in-body-Attendance-Holiday col-6">
                                    <div className="employee-text-in-Attendance-Holiday">
                                        <h2>Recas</h2>
                                    </div>
                                    <div className="input-for-search-in-employee-Attendance-Holiday">
                                        <MdSearch className="search-icon-in-Attendance-Holiday" />
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            onChange={(e) => handleDataSearch(e)}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="table-in-all-emplyee-Attendance-Holiday">
                                <table className="table-main-Attendance-Holiday">
                                    <thead className="thead-main-Attendance-Holiday">
                                        <tr className="row-12">
                                            <th className="image-class-Holiday col-2 ">
                                                Sr. no
                                            </th>
                                            <th className="image-class-Holiday col-2 ">
                                                Person Name
                                            </th>
                                            <th className="image-class-Holiday col-2 ">Department</th>
                                            <th className="image-class-Holiday col-2 ">Designation</th>
                                            <th className="image-class-Holiday col-2 ">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="tbody-main-Attendance-Holiday">
                                        {getAllUser?.sort((a, b) => a.UserName.localeCompare(b.UserName))?.map((item, index) => (
                                            <tr key={index}>
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td> {item?.UserName}</td>
                                                    <td> {item?.Designation ? item?.Designation : "-"}</td>
                                                    <td> {item?.Department ? item?.Department : "-"}</td>
                                                    <td>
                                                        <button className="screenshot-button" onClick={() => handleshowHolidayModal(item)}>View Activity</button>
                                                    </td>
                                                </>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>
            </div>


            {showModal && (
                <div
                    className="modal show edit-leaveModal"
                    style={{ display: "block" }}
                >
                    <Modal.Dialog>
                        <Modal.Header closeButton onClick={handleCloseModal}>
                            <Modal.Title>Recas </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="addemp-react-select-input">
                                <label htmlFor="">Month</label>
                                <Select
                                    classNamePrefix="EMP-leave-request-input"
                                    placeholder="Select Month"
                                    options={monthOptions}
                                    onChange={(selectedOption) => {
                                        if (selectedOption && selectedOption.dates) {
                                            setMonthStartDate(selectedOption.dates.startDate);
                                            setMonthEndDate(selectedOption.dates.endDate)
                                        }
                                    }}
                                //   getOptionLabel={(options) => options?.Name}
                                //   getOptionValue={(options) => options?.Id}

                                />

                            </div>



                            <div className="addemp-react-select-input">
                                <label htmlFor="">Project</label>
                                <Select
                                    classNamePrefix="EMP-leave-request-input"
                                    placeholder="Select Project"
                                    onChange={(e) => setProjectId(e?.value)}

                                    options={projectDetails?.map(project => ({
                                        value: project.Id,
                                        label: project.Name
                                    }))}                                //   getOptionLabel={(options) => options?.Name}
                                //   getOptionValue={(options) => options?.Id}
                                />
                            </div>

                            {/* <p>Date: {deleteItem?.FromDate?.split("T")[0]}</p>
                            <p>Day: {deleteItem?.Days}</p> */}
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                className="Delete-modal-close-button"
                                onClick={handleCloseModal}
                            >
                                Close
                            </button>
                            <button
                                className="Delete-modal-delete-button"
                                onClick={handleSubmitModel}
                            >
                                Submit
                            </button>
                        </Modal.Footer>
                    </Modal.Dialog>
                </div>
            )}
        </>
    );
};
export default RecasUserTable;
